import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'

import RaisedButton from 'material-ui/RaisedButton'
import Paper from 'material-ui/Paper'
import TextField from 'material-ui/TextField'

import PerfomanceSection from '../PerfomanceSection'
import PropertyAvatar from './PropertyAvatar'

import { doc, dirtyRead } from 'selectors/common'

let select = dirtyRead(
	(state, props) => ({
		property: doc(state, props.propertyID)
	})
)

export class LeftSide extends Component{
	render(){
		let { props } = this
		if (!props.property) return null
		return(
			<div
				key={props.property.alias}
				className="left-side"
				style={{
					width: (this.props.colspan>1) ? "50%" : "100%"
				  , overflowY: "auto"
				  , overflowX: "hidden"
				  , position: "relative"
				  , padding: "10px"
				}}
			>
				<Paper
					style={{
						backgroundColor: "#fff"
					  , display: "inline-block"
					  , width: "100%"
					  , padding: "15px"
					}}
				>
					<div style={{display: "inline-block", float: "left"}}>
						<PropertyAvatar objectID={props.propertyID} propertyID={props.propertyID}/>
					</div>
					<div style={{display: "inline-block", float: "left", margin: "0 10px"}}>
						<p style={{fontSize: "18px", fontWeight: "bold", color: "#009688", margin: "5px 0 15px 0", textTransform: "uppercase"}}>
							{props.property.alias}
						</p>
						<p  style={{margin: "15px 0 5px 0"}}>
							{props.property.address.split(',')[0]}
						</p>
						<p style={{margin: "0"}}>
							{props.property.address && props.property.address.substring(props.property.address.indexOf(',') + 2)}
						</p>
						<div style={{display: "flex", justifyContent: "space-between", textAlign: "center", marginTop: "10px"}}>
							<div>
								<img src="/landlord/static/img/bed.png" height="20" alt="bed"/>
								<p style={{margin: "0", fontWeight: "bold"}}>{props.property.beds || 'N/A'}</p>
							</div>
							<div>
								<img src="/landlord/static/img/bath.png" height="20" alt="bed"/>
								<p style={{margin: "0", fontWeight: "bold"}}>{props.property.baths || 'N/A'}</p>
							</div>
							<div>
								<img src="/landlord/static/img/area.png" height="20" alt="bed"/>
								<p style={{margin: "0", fontWeight: "bold"}}>{props.property.sqFootage || 'N/A'}</p>
							</div>
						</div>
					</div>
					<div style={{display: "inline-block", float: "right"}}>
						<Link
							style={{textDecoration: 'none'}}
							to={"/landlord/property/"+props.propertyID}
						>
							<RaisedButton
								label="EDIT"
								icon={<i className="material-icons" style={{color: "#FFF", fontSize: "18px"}}>mode_edit</i>}
								backgroundColor="#009688"
								labelColor="#FFF"
							/>
						</Link>
					</div>
				</Paper>
				<PerfomanceSection selectedProperty={this.props.propertyID}/>
			</div>

		)
	}
}

export default connect(select)(LeftSide)



// WEBPACK FOOTER //
// ./src/routes/landlord/dashboard/propertyForm/LeftSide.js